import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";

import { bindActionCreators } from "redux";
import { getManageableAssociations } from "../../data/actions/associationActions";
import { AdminPageLayout } from "../admin/common";

import { IReport } from "../../types/reports/reports";

import ReportsApi from "../../data/api/reportsApi";
import { CenteredLoader } from "../common/loader";
import { IAssociation } from "../../types/association/Association";
import ReportItem from "./ReportItem";
import AppointmentReportingPanel from "./AppointmentReportingPanel";
import { IPerson } from "../../types/persons/person";
import { IState } from "../../data/reducers/state";

interface ReportsListProps {
  actions: any;
  selectedAssociation?: IAssociation | null;
  currentPerson?: IPerson | null;
}

const ReportsList: React.FunctionComponent<ReportsListProps> = (props) => {
  const [list, setList] = React.useState<IReport[] | null>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<null | string>(null);

  const loadList = () => {
    setIsLoading(true);
    setError(null);

    props.actions.getManageableAssociations();

    ReportsApi.getList()
      .then((list) => {
        setList(list);
        setIsLoading(false);
      })
      .catch((er) => {
        setIsLoading(false);
        setError(er.message);
      });
  };

  if (!list && !isLoading && !error) {
    loadList();
    return <CenteredLoader />;
  }

  if (isLoading) {
    return <CenteredLoader />;
  }

  return (
    <AdminPageLayout
      title="Reports"
      description="Generate various reports for your association data and operations"
      icon={faChartBar}
      showCard={false}
    >
      <AppointmentReportingPanel
        associationId={props.selectedAssociation?._id || undefined}
        currentPerson={props.currentPerson}
      />
      <div className="mb-4">
        <p className="text-muted">
          This page lists the reports that are possible to generate with Stadium
          Supervisor. New reports are added from time to time. If you have
          custom reports you'd like to generate, please contact{" "}
          <a href="mailto:support@stadiumsupervisor.com.au" className="text-primary">
            support@stadiumsupervisor.com.au
          </a>
          . A fee may apply for special, custom reports.
        </p>
      </div>

      {error && (
        <div className="alert alert-danger mb-4">
          <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
          {error}
        </div>
      )}

      <div className="row">
        {(list || []).map((rep) => (
          <div key={rep.title} className="col-12 mb-4">
            <ReportItem 
              report={rep} 
              selectedAssociation={props.selectedAssociation}
            />
          </div>
        ))}
      </div>
    </AdminPageLayout>
  );
};

const mapStateToProps = (state: IState) => {
  const selfId = state.persons.self;
  return {
    currentPerson: selfId ? state.persons.map[selfId] : null,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ getManageableAssociations }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportsList);
